import {getTrianglePoints} from './raster.js';
import {sortPts} from './sort.js';

export const drawContours = (A, B, C, c, step=2, color="#ffffff") => {


    let tri = [A,B,C];
    sortPts(tri);

    c.beginPath();
    c.lineWidth = 2;
    c.moveTo(tri[0].x, tri[0].y);
    c.lineTo(tri[1].x, tri[1].y);
    c.lineTo(tri[2].x, tri[2].y);
    c.closePath();
    
    c.fillStyle = "black";
    c.fill();
    
    let {triangles, points, contours, segments}= getTrianglePoints(tri, step, 100);

    if (step > 0) {
        c.lineWidth= 1;
    }  else {
        c.lineWidth= Math.max(1, Math.pow(step, .5));
    }

    triangles.forEach(
        ([t1, t2, t3]) => {
            c.beginPath();
            c.moveTo(t1.x, t1.y);
            c.lineTo(t2.x, t2.y);
            c.lineTo(t3.x, t3.y);
            c.strokeStyle = "rgba(255, 255, 255," + 0.1 +")";
            c.stroke();
        });

    // contours = [];

    /*
      segments.forEach(
      l => {
      c.beginPath();
      c.moveTo(l[0].x, l[0].y);
      c.lineTo(l[1].x, l[1].y);
      c.strokeStyle = "red";
      c.stroke();
      });
    */
    // contours = [];
    
    contours.forEach(
        (l, i) => {
            if (l.length === 0) {
                return;
            }
            let d = `M ${l[0].x}, ${l[0].y} L ` + l.slice(1).map(({x,y}) => x+','+y).join(' ');
            //let d = spline(l, tension, false);
            
            let path = new Path2D(
                d);
            let r = ((i+1) / contours.length) * 244;
            let g = ((i+1) / contours.length) * 255/2;;
            let b = ((i+1) / contours.length) * 255/3;
            // i = Math.round(16*(i / contours.length));
            c.lineWidth = step < 10 ? 1 : Math.pow(step, 0.4);
            c.strokeStyle= color; // + i.toString(16);
            c.stroke(path);
        });
    
    points.forEach(
        pt => {
            c.beginPath();
            if (step<=4) {
                c.fillRect(pt.x, pt.y, 1, 1);
            } else {
                c.arc(pt.x, pt.y, 1, 0, 2*Math.PI);
            }
            c.fillStyle = "rgba(255, 255, 255," + 0.5*Math.random() +")";
            c.fill();
        });

    return;
};


